module.exports = __webpack_public_path__ + "img/Management_PC_CN@3x.ddd3a00a.png";